<template>
  <div class="page">
    <h2>隐私权政策</h2>
    <h2>更新日期：2024年09月06日</h2>
    <h2>提示条款：</h2>
    <p>
      上海第一财经投资管理有限公司（注册地址：上海市虹口区海宁路137号7层，以下或称“我们”“公司”“有看投”），您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴此，有看投（或简称“我们”）制定本《有看投隐私权政策》（下称“本政策/本隐私权政策”）并提醒您：本政策适用于有看投产品或服务。如我们关联公司产品或服务中使用了有看投提供的产品或服务但未设独立法律声明及隐私权政策的，则本政策同样适用于该部分产品或服务。本政策与您使用我们的服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款，采用粗体字进行标注以提示您注意。
      您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
      如对本政策或相关事宜有任何问题，请通过客服与我们联系。
    </p>
    <h2>本政策将帮助您了解以下内容：</h2>
    <p>1、我们如何收集和使用您的个人信息</p>
    <p>2、我们如何使用Cookie和同类技术</p>
    <p>3、我们如何共享、转让、公开披露您的个人信息</p>
    <p>4、我们如何保护您的个人信息</p>
    <p>5、您的权利</p>
    <p>6、未成年人保护方面</p>
    <p>7、您的个人信息如何在全球范围转移</p>
    <p>8、本政策如何更新</p>
    <p>9、如何联系我们</p>
    <h2>一、我们会出于本政策所述的以下目的，收集和使用您的个人信息：</h2>
    <p>（一）帮助您成为我们的会员</p>
    <p>
      为成为我们的会员，以便我们为您提供会员服务，您需要提供手机号码、电子邮箱地址，并创建用户名和密码。如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。
    </p>
    <p>
      在您主动注销账号时，我们将根据适用法律法规的要求尽快使其匿名或删除您的个人信息。
    </p>
    <p>（二）为您展示商品或服务</p>
    <p>
      为改善我们的产品或服务、向您提供个性化的信息搜索及交易服务，我们会根据您的浏览及搜索记录、设备信息、位置信息、订单信息，提取您的浏览、搜索偏好、行为习惯、位置信息等特征，基于特征标签进行间接人群画像并展示信息。
    </p>
    <p>（三）向您提供商品或服务</p>
    <p>1、您向我们提供的信息</p>
    <p>
      您可以通过有看投为其他人订购商品或服务，您需要提供该实际订购人的前述个人信息。向有看投提供该实际订购人的前述个人信息之前，您需确保您已经取得其授权同意。
    </p>
    <p>（四）监管与风险防范</p>
    <p>
      为了保障互联网应用的业务安全风控，应对欺诈、违法等安全风险，满足监管要求，提升服务安全性，防止您的个人信息被违法获取，您同意我们记录您使用产品的方式及相关操作信息，例如
      <strong>
        硬件序列号、操作系统版本、设备MAC地址、IP地址、无线网络接入信息、唯一设备识别码（如IMEI/Android
        ID/IDFA/Open
        UDID/GUID/SIM卡IMSI信息等个人常用设备基本情况的信息）、软件版本号、网络接入方式、类型、状态、操作、使用产品使用习惯以及其他与有看投服务相关的日志信息以及其他能识别客户终端的特征代码， </strong
      >这些信息是为提供服务必须收集的基础信息。除了产品基本功能外，我们还提供一些附加功能来提升用户体验，需要提供以下权限与信息：设备权限、位置信息。
    </p>
    <p>1、 设备权限</p>
    <p>
      在提供服务过程中，可能需要您开通一些设备权限，我们会通过弹窗等方式向您确认通知、WIFI及蜂窝数据的权限、拨打电话、摄像头、音频、麦克风、录音、相册或手机存储的权限，具体如下：
    </p>
    <p>（1） 通知</p>
    <p>
      允许通知，可以为您提供重点事项的通知（如评论、预警、活动、行业重要公告、系统升级等）、服务资讯的推送等。
      如您拒绝提供或希望关闭通知，您可以通过您的终端设备的设置菜单进行关闭选择，关闭通知，会影响向您提供重点事项的通知、服务资讯的推送等功能，但不影响您使用我们的其他服务。
    </p>
    <p>（2） WIFI及蜂窝数据的权限</p>
    <p>
      允许使用WLAN与蜂窝移动网。
      如您拒绝或希望关闭WIFI及蜂窝数据的权限，您可以在您的终端设备的设置菜单进行关闭选择，同时关闭这两个开关将会影响您使用我们的服务。
    </p>
    <p>（3） 电话、音频及麦克风权限</p>
    <p>
      允许拨打客服电话或接听工作人员的回电，提升客户服务效率。
      如您拒绝或希望关闭该功能，您可以通过在您的终端设备的设置菜单进行关闭选择，这将会影响我们向您及时通过电话、语音方式解答您的疑问与投诉；如您拒绝接听工作人员的回电，未能完成合规回访流程时，可能会影响您使用有看投的产品或服务。
    </p>
    <p>（4） 录音权限</p>
    <p>
      允许录音或通话录音权限。由于您在使用产品/服务过程中，需要进行风险提示、合规录音。
      如您拒绝或希望关闭该功能，您可以通过在您的终端设备的设置菜单进行关闭选择，这将会影响您接收风险提示，合规录音，可能会影响您使用有看投的产品或服务。
    </p>
    <p>（5） 摄像头、相机权限</p>
    <p>
      如您拒绝或希望关闭该功能，您可以通过在您的终端设备的设置菜单进行关闭选择，这将会影响您更换个人头像，拍照提供产品建议、上传材料以及视频功能，但并不影响您使用我们的其他服务。
    </p>
    <p>（6） 相册权限及手机存储权限</p>
    <p>
      允许获取您的相册权限及手机存储权限。
      如您拒绝或希望关闭该功能，您可以通过在您的终端设备的设置菜单进行关闭选择，这将会影响您更换个人头像、缓存资讯信息、使用图片的缓存、上传、保存、识别、编辑与分享功能，但并不影响您使用我们的其他服务。
    </p>
    <p>2、 位置信息</p>
    <p>
      在您使用有看投产品或服务时，开启设备定位功能并使用我们基于位置提供的相关服务时，会主动提示您获取您的确切位置信息（GPS和网络定位信息）。当您使用上述附加功能时，我们会取得相关权限的同意。您可以在设备的设置功能中随时选择关闭部分或全部权限，从而拒绝我们收集或提供相应的个人信息，但并不影响您使用我们的其他服务。在不同的设备中，权限设置的位置和开启、关闭方式可能不同，请以您使用设备的说明为准。
    </p>
    <p>3、 个人信息</p>
    <p>
      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。根据《信息安全技术个人信息安全规范》本指引中涉及的个人信息包括个人基本资料（个人姓名、生日、性别、民族、国籍、个人电话号码、电子邮件地址）；网络身份标识信息（个人信息主体账号、ip地址）；个人上网记录（网站浏览记录、软件使用记录、点击记录、收藏列表等）个人常用设备信息（指包括硬件序列号、设备MAC地址、软件列表、唯一设备识别码等在内的描述个人常用设备基本情况的信息）；
    </p>
    <p>
      您在使用我们的产品及服务时，以上信息需要选择授权我们收集和使用，主要用于付费产品的权限开通，及相应产品系统推荐等功能，同时应用在后台状态下获取使用个人信息（包含个人姓名、生日、性别、民族、国籍、个人电话号码、电子邮件地址等），用于我们基础业务服务。
    </p>
    <p>（五）第三方服务</p>
    <p>
      为了帮助您使用“消息通知”功能，我们可能会调用腾讯移动推送 TPNS
      SDK，可能会收集您的设备信息，用于为您提供消息推送服务，具体详见该第三方的隐私政策<a
        href="https://cloud.tencent.com/document/product/548/50955"
        >https://cloud.tencent.com/document/product/548/50955</a
      >；
    </p>
    <p>
      为与您使用的终端机型适配消息通知功能，我们可能会通过相应SDK与终端设备制造商共享手机型号、版本及相关设备信息，具体如下：
    </p>
    <table>
      <tr>
        <td>第三方SDK名称</td>
        <td>SDK 用途</td>
        <td>隐私政策链接</td>
        <td>收集个人信息类型</td>
      </tr>
      <tr>
        <td>小米推送 SDK</td>
        <td>对小米品牌手机消息推送</td>
        <td>
          <a href="https://privacy.mi.com/all/zh_CN/"
            >https://privacy.mi.com/all/zh_CN/</a
          >
        </td>
        <td>
          设备标识(0AID、加密的Android
          ID、IMEI)、推送消息内容、设备信息(设备厂商、MAC地址、型号、归属地、运营商名称等)、通知栏设置
        </td>
      </tr>
      <tr>
        <td>华为推送 SDK</td>
        <td>对华为品牌手机消息推送</td>
        <td>
          <a href="https://www.huawei.com/cn/privacy-policy"
            >https://www.huawei.com/cn/privacy-policy</a
          >
        </td>
        <td>网络状态信息、设备信息、存储信息、位置信息</td>
      </tr>
      <tr>
        <td>OPPO 推送 SDK</td>
        <td>对OPPO品牌手机消息推送</td>
        <td>
          <a href="https://www.oppo.com/cn/support/service-policy/privacy/#"
            >https://www.oppo.com/cn/support/service-policy/privacy/#</a
          >
        </td>
        <td>设备信息</td>
      </tr>
      <tr>
        <td>vivo 推送 SDK</td>
        <td>对vivo品牌手机消息推送</td>
        <td>
          <a href="https://www.vivo.com.cn/about-vivo/privacy-policy"
            >https://www.vivo.com.cn/about-vivo/privacy-policy</a
          >
        </td>
        <td>设备信息</td>
      </tr>
      <tr>
        <td>魅族推送 SDK</td>
        <td>对魅族品牌手机消息推送</td>
        <td>
          <a href="https://i.flyme.cn/privacy?lang=zh_CN"
            >https://i.flyme.cn/privacy?lang=zh_CN</a
          >
        </td>
        <td>设备信息</td>
      </tr>
      <tr>
        <td>APNs SDK</td>
        <td>对苹果品牌手机消息推送</td>
        <td>
          <a href="https://www.apple.com/legal/privacy/en-ww/"
            >https://www.apple.com/legal/privacy/en-ww/</a
          >
        </td>
        <td>设备信息</td>
      </tr>
      <tr>
        <td>Bugly SDK</td>
        <td>统计分析，收集AndroidID用于崩溃分析、问题检测和用户行为数据统计</td>
        <td>
          <a
            href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
            >https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a
          >
        </td>
        <td>设备信息、网络类型、应用当前正在运行的进程名、PID、AndroidID</td>
      </tr>
      <tr>
        <td>腾讯浏览服务X5网页引擎SDK</td>
        <td>提供展示及播放服务</td>
        <td>
          <a
            href="https://rule.tencent.com/rule/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d"
            >https://rule.tencent.com/rule/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d</a
          >
        </td>
        <td>设备信息、应用信息、Wi-Fi状态和参数</td>
      </tr>
      <tr>
        <td>号码认证 SDK</td>
        <td>方便用户一键登录</td>
        <td>
          <a
            href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html"
            >https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html</a
          >
        </td>
        <td>网络类型、切换wifi和蜂窝网络通道、设备信息</td>
      </tr>
      <tr>
        <td>新浪微博 SDK</td>
        <td>内容分享</td>
        <td>
          <a href="https://weibo.com/signup/v5/privacy"
            >https://weibo.com/signup/v5/privacy</a
          >
        </td>
        <td>头像、昵称、地区、性别、网络信息、设备信息</td>
      </tr>
    </table>

    <p>
      为了统计分析等目的，我们可能会调用友盟SDK，收集您的设备信息（IMEI/MAC/Android
      ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等），具体详见该第三方的隐私政策<a
        href="https://www.umeng.com/page/policy"
        >https://www.umeng.com/page/policy</a
      >。
    </p>
    <p>
      当您使用直播课、视频功能时，我们可能会调用第三方平台提供的SDK，前述SDK可能需要音频权限。
    </p>
    <p>
      当您使用第三方服务（QQ、微信）进行资讯/视频等内容的分享时，我们可能会调用第三方平台提供的SDK，涉及的个人信息包含在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息）。
    </p>
    <p>
      支付功能由我们合作的第三方支付机构（微信、支付宝等）向您提供服务，有看投IOS版本的苹果内购支付服务由苹果公司负责提供。第三方支付机构可能需要收集您的姓名、银行卡类型及卡号、有效期以及手机号码。银行卡号、有效期及手机号码属于敏感信息，如果您拒绝提供将导致您无法使用该功能，但不影响您正常使用其他功能。
    </p>
    <p>第三方服务的免责</p>
    <p>
      我们的服务可能包括或链接至第三方提供的信息或其他服务（包括第三方的网站），第三方服务可能会调用您的设备权限、获取您的相关信息。有看投会尽可能对第三方服务进行严格的审核，要求其采取严格的数据保护措施，切实保障您的合法权益。
    </p>
    <p>
      关于第三方服务涉及的权限以及如何收集、使用您的个人信息，建议您仔细阅读第三方服务的相关服务协议及隐私政策条款，谨慎提供个人信息。如您发现第三方服务存在风险时，建议您终止相关操作以保护您的合法权益。
    </p>
    <p>
      本隐私政策仅适用于我们提供的产品或服务，不适用于任何第三方提供的服务或第三方的个人信息安全政策，有看投对任何第三方收集、使用、处理由您提供或授权的信息（包括您的个人信息）不承担任何责任。
    </p>
    <p>（六） 提升服务质量</p>
    <p>
      为提高您对有看投产品或服务使用感受和满意度，我们可能会收集您的操作行为信息、搜索记录、您与客户服务团队联系时提供的信息及您参与问卷调查时向我们发送的信息，以便进行调查研究和分析，从而进一步优化服务。
      <strong
        >请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程等方式向您说明收集的内容、范围和目的，以征得您的同意。</strong
      >
    </p>
    <p>2、我们在您使用服务过程中收集的信息</p>
    <p>
      为向您提供更契合您需求的页面展示和搜索结果、了解产品适配性、识别账号异常状态，我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：
    </p>
    <p>
      设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站等传感器信息），用于统计分析、适配消息通知功能等目的。
    </p>
    <p>
      日志信息：在您访问我们的网站或使用我们的服务时，我们可能会收集日志信息，主要用于记录您浏览我们产品或服务时的行为，在进行特殊处理且无法定位到特定用户后，用于数据分析来改善产品服务及用户体验，及时发现并防范安全风险。
    </p>
    <p>
      位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；您可以通过关闭定位功能，停止对您的地理位置信息的收集。
    </p>
    <p>
      请注意，单独的设备信息、日志信息、位置信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
    </p>
    <p>
      为展示您账户的订单信息，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。
    </p>
    <p>
      当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
    </p>
    <p>3、我们通过间接获得方式收集到的您的个人信息</p>
    <p>
      当您通过我们产品或服务使用上述服务时，您授权我们根据实际业务及合作需要从我们关联公司处接收、汇总、分析我们确认其来源合法或您授权同意其向我们提供的您的个人信息或交易信息。
    </p>
    <p>
      如您拒绝提供上述信息或拒绝授权，可能无法使用我们关联公司的相应产品或服务，或者无法展示相关信息，但不影响使用有看投网站浏览、搜索、交易等核心服务。
    </p>
    <p>（七）为您提供安全保障</p>
    <p>
      为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或有看投相关协议规则的情况，我们可能使用或整合您的会员信息、交易信息、设备信息、有关网络日志以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
    </p>
    <p>（八）其他用途</p>
    <p>
      我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
    </p>
    <p>（九）征得授权同意的例外</p>
    <p>
      根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：
    </p>
    <p>1、与国家安全、国防安全有关的；</p>
    <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>
      4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
    </p>
    <p>5、所收集的个人信息是您自行向社会公众公开的；</p>
    <p>
      6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
    </p>
    <p>7、根据您的要求签订合同所必需的；</p>
    <p>
      8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
    </p>
    <p>9、为合法的新闻报道所必需的；</p>
    <p>
      10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
    </p>
    <p>11、法律法规规定的其他情形。</p>
    <p>
      如我们停止运营有看投产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
    </p>
    <h2>二、我们如何使用Cookie和同类技术</h2>
    <p>（一）Cookie</p>
    <p>
      我们会在您的计算机或移动设备上存储名为Cookie的小数据文件，用于确保网站正常运转、使您获得更轻松的访问体验。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好或购物篮内的商品等数据。
    </p>
    <p>
      您可根据自己的偏好管理或删除Cookie。有关详情，请见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
    </p>
    <p>（二）网站信标和像素标签</p>
    <p>
      除Cookie外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
    </p>
    <h2>三、我们如何共享、转让、公开披露您的个人信息</h2>
    <p>（一）共享</p>
    <p>
      我们不会与有看投服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
    </p>
    <p>
      1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
    </p>
    <p>
      2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
    </p>
    <p>
      3、与关联公司间共享：为便于我们基于关联账号共同向您提供服务，或保护有看投关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您使用有看投账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息），如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
    </p>
    <p>
      4、与授权合作伙伴共享：仅为实现本隐私权政策中声明的目的，我们的某些服务将由我们和授权合作伙伴共同提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您上网购买我们的产品时，我们必须与配送服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。
    </p>
    <p>目前，我们的授权合作伙伴包括以下类型：</p>
    <p>
      （1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴共享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。例如，只有在广告主同意遵守我们的广告发布准则后，我们才可能会告诉广告主他们广告的效果如何，或者有多少人看了他们广告或在看到广告后安装了应用，或者向这些合作伙伴提供不能识别个人身份的统计信息（例如“男性，25-29岁，位于北京”），帮助他们了解其受众或顾客。
    </p>
    <p>
      （2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。
    </p>
    <p>
      对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的数据保护协定，要求他们按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。
    </p>
    <p>（二）转让</p>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>
      1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
    </p>
    <p>
      2、在有看投服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
    </p>
    <p>（三）公开披露</p>
    <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
    <p>1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
    <p>
      2、如果我们确定您出现违反法律法规或严重违反有看投相关协议规则的情况，或为保护有看投及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或有看投相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及有看投已对您采取的措施。
    </p>
    <p>
      3、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
    </p>
    <p>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
    <p>
      以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
    </p>
    <p>1、与国家安全、国防安全有关的；</p>
    <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>
      4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p>5、您自行向社会公众公开的个人信息；</p>
    <p>
      6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
    </p>
    <p>
      根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
    </p>
    <h2>四、我们如何保护您的个人信息</h2>
    <p>
      （一）我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL（SecureSocketLayer）协议加密保护；我们同时对有看投网站提供HTTPS（HyperTextTransferProtocoloverSecureSocketLayer）协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
    </p>
    <p>
      （二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。
    </p>
    <p>
      （三）我们只会在达成本政策所述目的所需的期限内或法律要求的期限内保留您的个人信息，除非延长保留期征得您的同意或受到法律的允许。
    </p>
    <p>
      （四）互联网并非绝对安全的环境，我们强烈建议您不要使用非有看投推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。
    </p>
    <p>
      在使用有看投服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络有看投客服，以便我们根据您的申请采取相应措施。
    </p>
    <p>
      请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
    </p>
    <p>
      （五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过有看投公告方式获得。
    </p>
    <p>
      （六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
    </p>
    <p>同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
    <h2>五、您的权利</h2>
    <p>
      我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。您有权利查询、更正、管理、删除自己的信息并保护自己的隐私和安全。
    </p>
    <p>(一)访问您的个人信息</p>
    <p>
      除法律法规规定的例外情况，无论您何时使用我们的服务，我们都会力求让您顺利访问自己的个人信息。您可以通过如下方式行使您的访问权利
    </p>
    <p>
      1.帐户信息：如果您希望访问或编辑您的帐户中的个人资料信息、更改您的密码、添加安全信息等，您可以在您使用的产品中执行此类操作。
    </p>
    <p>2.订单信息：您可以在我们系统中查阅或清除您的订单记录，交易记录等。</p>
    <p>(二)更正或补充您的个人信息</p>
    <p>
      当您需要更新您的个人信息时，或发现我们处理您的个人信息有错误时，您有权作出更正或更新。您可以自行在我们系统内进行更正，或通过反馈与报错等将您的更正申请提交给我们。在您进行更新或更正前，我们可能会先要求您验证自己的身份，然后再处理您的请求。
    </p>
    <p>(三)删除您的个人信息</p>
    <p>1.您可以通过产品中的设置或功能控件删除您的信息。</p>
    <p>2.发生以下情形，您可以向我们提出删除个人信息的请求：</p>
    <p>a)如果我们处理个人信息的行为违反法律法规；</p>
    <p>b)如果收集、使用您的个人信息，却未征得您的同意；</p>
    <p>c)如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>d)如果我们终止产品运营及服务。</p>
    <p>
      若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。
    </p>
    <p>
      当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
    </p>
    <p>(四)改变您授权同意的范围</p>
    <p>
      1.您可以通过解除绑定、修改个人设置、删除相关信息等方式撤回部分授权，也可以通过关闭功能的方式撤销授权。
    </p>
    <p>
      2.当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
    </p>
    <p>(五)个人信息主体注销账户</p>
    <p>您可以联系有看投客服提交账户注销申请。</p>
    <p>
      在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。
    </p>
    <p>
      (六)约束信息系统自动决策
      在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害有看投商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
    </p>
    <p>(七)响应您的上述请求</p>
    <p>
      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
    </p>
    <p>我们将在15天内做出答复。如您不满意，还可以通过有看投客服发起投诉。</p>
    <p>
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
    </p>
    <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
    <p>1、与国家安全、国防安全有关的；</p>
    <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3、与犯罪侦查、起诉、审判和执行判决等有关的；</p>
    <p>4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
    <p>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
    <p>6、涉及商业秘密的。</p>
    <h2>六、未成年人保护方面</h2>
    <p>
      1、若您是未满18周岁的未成年人，您应在您的监护人监护、指导下并获得监护人同意的情况下，认真阅读并同意本协议后，方可使用有看投软件及相关服务。若您未取得监护人的同意，监护人可以通过联系上海第一财经传媒有限公司官方公布的客服联系方式通知公司处理相关账号，上海第一财经传媒有限公司有权对相关账号的功能、使用进行限制，包括但不限于浏览、发布信息、互动交流等功能。
    </p>
    <p>
      2、上海第一财经传媒有限公司重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并应在取得监护人的同意以及在监护人指导下正确使用有看投软件及相关服务。
    </p>
    <p>
      3、未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而可能导致的全部法律责任。
    </p>
    <p>4、未成年人用户特别提示</p>
    <p>
      （1）未成年人使用有看投软件及相关服务应该在其监护人的监督指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好上网习惯；
    </p>
    <p>（2）青少年用户必须遵守《全国青少年网络文明公约》；</p>
    <p>
      （3）要善于网上学习，不浏览不良信息；
    </p>
    <p>（4）要诚实友好交流，不侮辱欺诈他人；</p>
    <p>
      （5）要增强自护意识，不随意约会网友；
    </p>
    <p>
      （6）要维护网络安全，不破坏网络秩序；
    </p>
    <p>（7）要有益身心健康，不沉溺虚拟时空。</p>
    <p>
      5、为更好地保护未成年人隐私权益，上海第一财经传媒有限公司特别提醒您慎重发布包含未成年人素材的内容，一经发布，即视为您已获得权利人同意在有看投软件及相关服务展示未成年人的肖像、声音等信息，且允许上海第一财经传媒有限公司依据本协议使用、处理该等与未成年人相关的内容。
    </p>
    <p>6、监护人特别提示</p>
    <p>
      （1）如您的被监护人使用有看投软件及相关服务的，您作为监护人应指导并监督被监护人的注册和使用行为，如您的被监护人申请注册有看投账号，公司将有权认为其已取得您的同意；
    </p>
    <p>
      （2）您的被监护人在使用有看投软件及相关服务时可能使用购买产品或服务等功能。您作为监护人，请保管好您的支付设备、支付账户及支付密码等，以避免被监护人在未取得您同意的情况下通过您的有看投账号使用购买等消费功能。
    </p>
    <h2>七、您的个人信息如何在全球范围转移</h2>
    <p>
      原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。
    </p>
    <p>
      由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。
    </p>
    <p>
      此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。
    </p>
    <h2>八、本隐私权政策如何更新</h2>
    <p>
      我们可能适时会对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以标注更新时间的方式公布在我们网站上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、理解并接受修改后的隐私权政策并受其约束。
    </p>
    <h2>九、如何联系我们</h2>
    <p>如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：</p>
    <p>邮箱：【 cbnclub@yicai.com 】；电话：【400-602-1010】</p>
    <p>我们设立了个人信息保护专职部门，您可以通过有看投客服与其联系。</p>
    <h2>互联网新闻信息服务许可证：31120180001</h2>
    <div id="btnCancel" class="btn-cancel" onclick="showCancelAgreeDialog()">
      撤回同意并退出软件
    </div>
  </div>
</template>
<style>
html,
body {
  background-color: #ffffff;
  word-break: break-all;
}
table {
  margin: 20px 0;
  min-height: 25px;
  line-height: 45px;
  text-align: center;
  border-collapse: collapse;
}
table,
table tr th,
table tr td {
  border: 1px solid #000;
}
td {
  padding: 0 10px;
}

* {
  padding: 0;
  margin: 0;
}

.black body,
body.black {
  background-color: #111112;
  color: #bfbfbf;
}

a {
  color: #4690ef;
}

.page {
  padding: 15px 15px 30px;
  max-width: 640px;
  margin: 0 auto;
  font-size: 30px;
}

h2 {
  font-weight: bold;
  font-size: 32px;
  margin: 15px 0;
}

p {
  text-indent: 2em;
}

.btn-cancel {
  margin: 45px 22px 0;
  border: 1px solid #dddddd;
  border-radius: 5px;
  line-height: 44px;
  text-align: center;
  font-size: 17px;
  color: #8c8c8c;
  display: none;
}

.black .btn-cancel {
  border-color: #1e262a;
  color: #828282;
}
</style>
<script src="https://appstatic.emoney.cn/js/log.js"></script>
<script>
var getParam = function(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r && r[2]) {
    return r[2]
  }

  return ''
}

var className = ''

if (getParam('css') === 'night') {
  className += ' black'
}

var ele = document.documentElement || document.body

ele.setAttribute('class', className)
</script>
